// src/components/AntaresLogo.tsx
import React from 'react';
export default function AntaresLogo({ className = 'h-10 w-auto', style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <img
      src="/logotopo_svgTrans.svg"
      alt="Antares Tecnologia GTA"
      className={className}
      style={{ objectFit: 'contain', ...style }}
    />
  );
}

